import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { Observable, Subscription, timer } from 'rxjs';
import { SharedModule } from '../shared/shared.module';
import { CloseButtonTheme } from '../ui-elements/close-button/close-button-theme.enum';
import { CloseButtonComponent } from '../ui-elements/close-button/close-button.component';
import { HeaderMessageService } from './header-message.service';
import { MessageOptions } from './message-options.model';
import { MessageType } from './message-type.enum';
import { MessageInterface } from './message.model';

@Component({
  selector: 'app-header-message',
  templateUrl: './header-message.component.html',
  styleUrls: ['./header-message.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SharedModule],
})
export class HeaderMessageComponent implements OnInit, OnDestroy {
  private headerMessageService = inject(HeaderMessageService);

  @ViewChild('buttonComponent', { read: ViewContainerRef, static: true }) buttonComponent: ViewContainerRef;

  messageTypes = MessageType;
  currentMessage: MessageInterface;
  private subscription: Subscription;
  private timer: Observable<any>;
  closing = false;

  ngOnInit() {
    this.headerMessageService.getMessageSubject().subscribe((message: MessageInterface) => {
      if (message) {
        message.options = { ...new MessageOptions(), ...message.options };
        this.currentMessage = { text: message.text, type: message.type, options: message.options } as MessageInterface;

        if (message.options.closable && !message.options.buttonComponent) {
          message.options.buttonComponent = CloseButtonComponent;
          message.options.onButtonClick = () => {
            this.close();
          };
        }

        if (message.options.buttonComponent) {
          this.buttonComponent.clear();
          const instance: any = this.buttonComponent.createComponent(message.options.buttonComponent).instance as any;
          instance.theme = CloseButtonTheme.HEADER_MESSAGE;
          instance.clicked.subscribe(() => {
            message.options.onButtonClick();
          });
        }

        if (message.options.autoClose) {
          this.setTimer(message.options.closeAfter || 6000);
        }
      } else {
        this.close();
      }
    });
  }

  setTimer(time) {
    this.stopCurrentTimer();
    this.timer = timer(time);
    this.subscription = this.timer.subscribe(() => {
      this.close();
    });
  }

  close() {
    this.closing = true;
    timer(500).subscribe(() => {
      this.closing = false;
      this.currentMessage = null;
    });
  }

  private stopCurrentTimer() {
    if (typeof this.subscription !== 'undefined') {
      this.subscription.unsubscribe();
    }
  }

  ngOnDestroy() {
    this.stopCurrentTimer();
  }
}
